<template>
  <div>
    <div class="info">
      <div class="pic"
           v-lazy:background-image="proxy + base64(info.pic)"
           v-lazy:error="proxy + base64(info.pic)"
           v-if="isProxy"
      >
        <span class="note">{{ info.sourceKey | vodSourceFilter }} <span v-if="info.sourceKey && info.note">|</span> {{ info.note }} </span>
      </div>
      <div class="pic"
           v-lazy:background-image="info.pic"
           v-lazy:error="proxy + base64(info.pic)"
           v-else
      >
        <span class="note">{{ info.sourceKey | vodSourceFilter }} <span v-if="info.sourceKey && info.note">|</span> {{ info.note }} </span>
      </div>
      <div class="title">
        {{ info.name }}
      </div>
    </div>
  </div>
</template>

<script>
import { Base64 } from 'js-base64'
import { baseMixin } from '@/libs/app-mixin'

export default {
  name: 'VodInfo',
  mixins: [baseMixin],
  props: {
    info: {
      type: Object
    },
    isProxy: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      // proxy: 'http://192.168.68.104:9700/vod/proxy?url='
      proxy: 'http://cloud.ai-ifast.com/mesh/cloud/vod/proxy?url='
    }
  },
  methods: {
    base64 (str) {
      return Base64.encode(str)
    }
  }
}
</script>

<style lang="less">

.info {
  display: flex;
  flex-direction: column;
  justify-items: center;
  align-items: center;
  min-height: 210px;
  background-color: #fff;
  margin: 5px 5px 5px;

  .pic {
    height: 160px;
    width: 100%;
    background-size: cover;

    .note {
      width: 100%;
      height: 20px;
      background-color: rgba(0, 0, 0, 0.5);
      color: #fff;
      font-size: 12px;
      z-index: 100;
      margin-left: 2px;
      padding-left: 5px;
      padding-right: 5px;
    }
  }

  .title {
    margin: 5px 5px 0px;
    font-size: 14px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/blocks/vod/VodInfo.vue